import React from "react";

export default function ResultsBiosensor(props) {
    return (
        <div>
            <div
                style={{
                    background: "rgb(175,234,255) linear-gradient(180deg, rgba(175,234,255,1) 0%, rgba(87,174,255,1) 47%, rgba(40,57,255,1) 100%)",
                    minHeight: "100vh",
                }}>
                <div
                    className="fixed bottom-0 w-full py-8 px-4 flex justify-around text-2xl text-white cano"
                    style={{backgroundColor: "rgba(87,174,255,.7)"}}>
                    <a href="#ESR1_HD22_title">ESR1_HD22</a>
                    <a href="#Chitosan_beads_title">Chitosan beads</a>
                    <a href="#Inteins_title">Inteins</a>
                    <a href="#IntAssay_title">IntAssay</a>
                    <a href="#Immobilization_title">Immobilization</a>
                    <a href="#References_title">References</a>
                </div>
                <div className="hero">
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/engineering/moneda-biosensor.png"
                        alt="Biosensor coin"
                        className="w-full"
                    />
                    <div className="w-full flex justify-around items-center">
                        <div onClick={props.switchPage} className="p-8 clickable">
                            <svg
                                width="76.7"
                                height="135.2"
                                viewBox="0 0 59 104"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M55 4L7 52L55 100" stroke="#233876" stroke-width="9"/>
                            </svg>
                        </div>

                        <div className="flex flex-col items-center">
                            <h2 className="text-3xl cano text-blue-900"> RESULTS </h2>
                            <h1 className="text-8xl cano text-blue-900"> BIOSENSOR</h1>
                        </div>
                        <div onClick={props.switchPage} className="p-8 clickable">
                            <svg
                                width="76.7"
                                height="135.2"
                                viewBox="0 0 59 104"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M4 100L52 52L4 4" stroke="#233876" stroke-width="9"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="h-full w-full">
                    <div className="p-10 max-w-6xl m-auto pt-20 text-white">
                        <h1
                            id="ESR1_HD22_title"
                            className="text-6xl text-center text-white font-bold">
                            Results Biosensor
                        </h1>
                        <h3 className="text-3xl font-bold cano">ESR1</h3>
                        <label htmlFor="Tabla1Biosensor" className="underline text-blue-400">
                            To see the improvement of an existing part, click here.
                        </label>
                        <h3 className="h3 cano">In silico</h3>
                        Construction ESR1_HD22_NsO (2113 base pair):
                        <p className="p"></p> ● Primers site (pF_HD22 and pR_HD22), Prefix, T7
                        Promoter, Lac operator, RBS, OmpA (periplasmic signal peptide), linker
                        for immobilization (CSGGGG), ESR1 (optimized for <i><i>E.coli</i></i>),
                        Histidine purification tag, T7 Terminator and Suffix. It was ensembled
                        and designed in SnapGene.
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/insilicoesr1.png"
                            alt="silco"
                        ></img>
                        <p className="figure_desc">
                            Fig 5. <i>In silico construction of ESR1. Assembled in SnapGene.</i>
                        </p>
                        <h3 className="h3 cano">Molecular docking</h3>
                        <h2 className="h2 cano font-bold">
                            <i>Characterization: protein modeling and molecular docking</i>
                        </h2>
                        <p className="p">
                            Observed molecular interactions between Human Estrogen Receptor
                            Alpha <i>hER alpha_HD22 </i>coded by BBa_K4260001 and some of its
                            ligands reported in literature such as Estradiol (natural ligand),
                            Carbamazepine, Bisphenol A and Diethyl Phthalate, chemical molecules
                            that act as Endocrine Disruptors.
                        </p>
                        <p className="p">
                            <i>hER alpha_HD22</i> through I-TASSER and the given results were
                            modeled at Chimera, the same as the ligands downloaded from PubChem.
                            The <i>hER alpha-ligands</i> docking (AutoDock Vina) was submitted
                            to Protein Plus, giving the interactions between ligands and
                            protein. Then, returning to the docking, we located these given
                            amino acids to verify if the union matched. The results are shown
                            below.
                        </p>
                        <br></br>
                        <h2 className="h2 cano">
                            Protein Model of our designed receptor molecule: Human Estrogen
                            Receptor Alpha (hERα_HD22)
                        </h2>
                        <p className="p">Name: Estrogen Receptor Alpha</p>
                        <p className="p">Molecular weight: 67.45 Da</p>
                        <p className="p">P.I: 8.29</p>
                        <p className="p">
                            Biobrick that codes for hERα_HD22: TecCEM 2022 - BBa_K4260001
                        </p>
                        <br></br>
                        <img
                            className="m-auto figure max-w-4xl"
                            src="https://static.igem.wiki/teams/4260/wiki/esr1-verde-bpa.png"
                            alt="molecular sim"
                            width="200"
                            height="200"
                        ></img>
                        <p className="figure_desc">
                            Fig 6.{" "}
                            <i>
                                Molecular simulation of our BBa_K4260001 including ESR1 coding
                                sequence (green) and CSGGGG linker (purple). Protein designed by
                                TecCEM 2022, modeled at Chimera.
                            </i>
                        </p>
                        <br></br>
                        <img
                            className="figure max-w-4xl m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/aaaa.png"
                            alt="silco2"
                        ></img>
                        <br></br>
                        <p>
                            Our protein keeps essential amino acids and regions where ligands
                            such as Bisphenol A, Carbamazepine, Diethyl phthalate and Estradiol
                            have a great affinity. The interactions of these ligands with the
                            amino acids indicated by Protein Plus are observed and confirmed by
                            docking.{" "}
                        </p>
                        <p className="p">
                            Also, in this modeling we observed that a wide range of the ligands'
                            possible interaction residues are not close to the linker and most
                            of them are in the opposite site, leaving that space for the
                            immobilization on chitosan and fitting the protein as we expect.
                        </p>
                        <h3 className="h3 cano font-bold">Wet lab</h3>
                        <h2 className="h2 cano font-bold">ESR1_HD22_NsO sequence:</h2>
                        <p className="p">
                            After ligation of ESR1_HD22_NsO (2113 base pairs) in plasmid pJET
                            1.2 (2974 bp) a transformation was performed in the competent <i>E.coli</i>
                            DH5 alpha strain for a high plasmid production. We sowed on petri
                            plates LB agar adding Ampicillin for the selection marker. From the
                            transformed plates; 4 candidate colonies were taken , plasmid was
                            extracted from them corresponding to ESR1 candidates 1-4 (integrity
                            shown in agarose gel electrophoresis).
                        </p>
                        <p className="p font-bold">For verification:</p>
                        <p className="p">
                            I. <b>Digestion</b> of the ligated plasmid “Plasmid ESR1 (2,4)” with
                            restriction enzymes NdeI was carried out to make sure the enzyme cut
                            the plasmid at the desired sites, producing expected fragment sizes.
                            Expecting 3936 bp y 1149 bp for ESR1.
                        </p>{" "}
                        <p className="p">
                            II. <b>PCR:</b> candidates ESR1 3 and 4 were amplified. A band on
                            the desired length was observed on the ESR1 (4).
                        </p>
                        <br></br>
                        <div className="flex justify-center max-w-3xl m-auto">
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/esr1plasmid-extractiondh5a.png"
                                alt="results"
                            ></img>
                            <p className="figure_desc">
                                Fig 19.{" "}
                                <i>
                                    Agarose gel electrophoresis 0.8% running 1Kb extended marker NEB
                                    (lane 5), and plasmid ESR1 (1), ESR1 (2), ESR1 (3), and ESR1 (4)
                                    extraction from <i>E.coli</i> DH5 alpha.
                                </i>
                            </p>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/esr1digestionncoi.png"
                                alt="results"
                            ></img>
                            <p className="figure_desc">
                                Fig 20.{" "}
                                <i>
                                    Digestion with restriction NdeI restriction enzyme, verified
                                    through agarose gel electrophoresis 0.8% running 1Kb extended
                                    marker NEB (lane 1), and plasmid ESR1 (2) and ESR1 (4).
                                </i>
                            </p>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/esr1pcrampli.png"
                                alt=""
                                className="figure"
                            />
                            <p className="figure_desc">
                                Fig 21.{" "}
                                <i>
                                    Amplification of the construct flanked by our primers region
                                    using PCR. Verified through agarose gel electrophoresis 0.8%
                                    running 1Kb extended marker NEB (lane 1), and plasmid ESR1 (3)
                                    and ESR1 (4). A 2111 bp band shown in ESR1 (4) as expected.
                                </i>
                            </p>
                        </div>
                        <p className="p">
                            So, after the digestion and PCR verification steps it was decided to
                            stay with ESR1 (4) for further protein purification.
                        </p>
                        <p className="p">
                            <i>E. coli</i> BL21 chemocompetent cells were transformed with
                            “Plasmids ESR1 (4)”. Afterwards, inoculation in a selective LB
                            culture medium with Ampicillin was performed for the{" "}
                            <b>protein expression and purification for ESR1.</b> Protein
                            solubility test was done to seek for the protein. Went further with
                            periplasmic protein <b>concentration </b>
                            following a specific procedure to extract them from the cell and run
                            it in a SDS-PAGE gel with the controls consisting of BL21’s total
                            protein and <i><i>E.coli</i></i> BL21 cloned expressing Laccase.{" "}
                        </p>
                        <br></br>
                        <img
                            className="m-auto figure max-w-md"
                            src="https://static.igem.wiki/teams/4260/wiki/esr1periplasmicfrac.png"
                        ></img>
                        <p className="figure_desc">
                            Fig 22.{" "}
                            <i>
                                SDS-PAGE for verifying presence of ESR1 in the periplasmic
                                fraction. Broad Lane 1) Range Protein Marker, lane 2) control;
                                LacTV, lane 3) control; full protein contained in BL21, lane 4)
                                ESR1 periplasmic protein and lane 5) control; full protein
                                contained in BL21.
                            </i>
                        </p>
                        <p className="p">
                            <b>
                                → Result: highly suggested expression found in periplasmic space.
                            </b>
                        </p>
                        <br></br>
                        <h3
                            id="Chitosan_beads_title"
                            className="text-3xl font-bold cano">
                            {" "}
                            Chitosan beads
                        </h3>
                        <p className="p">
                            (Functionality test for ESR1 found in periplasm)
                            Methodology followed in protocol book page 36
                        </p>
                        <br></br>
                        <img
                            className="m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/chitosan-beads-result.png"
                            alt="chitsanbeads"
                        ></img>
                        <p className="p">
                            In order to do a proper interpretation of the results, and to
                            eliminate the effect chitosan has on absorption of BPA and
                            Carbamazepine, the results must be reported as the difference
                            between chitosan with distilled water and chitosan with the protein.
                            There was no significant difference between them, therefore, it was
                            concluded that Carbamazepine was absorbed by chitosan and not by the
                            protein, the subtraction leaves 0 A. In the case of BPA it not was
                            absorbed, neither by the chitosan or the protein.{" "}
                        </p>
                        <img
                            className="m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/chitosan-tubes-results.png"
                            alt="chitosantubes"
                        ></img>
                        <p className="figure_desc">
                            Fig. 23 <i> Chitosan beads</i>
                        </p>
                        <p className="p">
                            Therefore we conclude that despite the advantages of the chitosan
                            beads for water treatment, coating gold nanoparticles with chitosan
                            is the better option for our bionsensor, hERa embedded in chitosan
                            does not allow interaction with EDCs.{" "}
                        </p>
                        <p className="p">
                            {" "}
                            2. Searching overexpression of hERa, the last resource implemented
                            was:
                        </p>
                        <p className="p">
                            Digestions of plasmid pET17b and of our construct with XbaI and
                            SpeI. Purification of the band with the GenElute™ Plasmid Miniprep
                            Kit was done and then the sequence was ligated following the
                            protocol book page 5, as a result the plasmid pET-17b-ESR1. A
                            control ligation with only the plasmid was done.
                        </p>{" "}
                        <br></br>- <i><i>E.coli</i></i> HMS174 were transformed with pET-17b-ESR1 and
                        pET-17b freshly ligated. It is expected to grow less colonies with the
                        control plasmid. The results fulfill this expectation.
                        <br></br>- Expression test for HMS174-pET17b-ESR1 was performed and
                        the SDS-PAGE with the samples were done, controls were elaborated
                        dutifully but the results weren't the expected ones, there was no
                        protein of the expected size being expressed.
                        <br></br>
                        <br></br>
                        <h3
                            id="Inteins_title"
                            className="text-3xl font-bold cano">Inteins</h3>
                        <br></br>
                        <h2 className="h2 cano font-bold">Construction RecA_inteins_HD22:</h2>
                        <p className="p">Primers site: pF_HD22 and pR_HD22, Prefix, T7 Promoter, Lac
                            operator, RBS, OmpA (periplasmic signal peptide), N-extein and
                            C-extein coding for blue chromoprotein AmilCP_BBa_K592009, N-intein
                            and C-intein of RecA, T7 terminator and Suffix.</p>
                        <p className="p">An <i>in silico</i> PCR overlap was runned in SnapGene to verify the
                            homologous regions. They did match and the result was the Construction
                            RecA_inteins_HD22.</p>
                        <br></br>
                        <img
                            className="figure max-w-9xl m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/complete-pcr-overlapping.png"
                            alt="completepcr"
                        ></img>
                        <p className="figure_desc">Fig 23. <i>Genetic constructs of Intein Mediated ESR1 with PCR
                            Overlapping homologous region shown in dark blue. Created in SnapGene.</i></p>
                        <p className="p">For synthesis RecA_inteins_HD22 were divided with
                            homologous regions to be united by PCR Overlap (figure a). Amplification of said
                            construction was performed (figure b). Results of
                            the PCR Overlap with controls being the sequences before PCR. Another
                            electrophoresis was run to amplify only the desired sequence. Size is
                            expected to be 3257 bp.</p>
                        <p className="p">- Ligation of RecA_inteins_HD22 with
                            3257 bp in pJET 1.2 blunt resulted in a plasmid of 6595 base pairs
                            (linearized with restriction enzymes <i>ScaI</i> and <i>SpeI</i>).</p>
                        <br></br>
                        <div className="flex justify-center max-w-md m-auto">
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/reca-overlaping-amplipcr.png"
                                alt="results"
                            ></img>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/reca-amplipcr.png"
                                alt="results"
                            ></img>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/reca-digestedspeiscai.png"
                                alt=""
                                className="figure"
                            />
                        </div>
                        <p className="figure_desc">Fig 24. <i>a) RecA mini intein ESR1 biosensor ligated through
                            overlapping PCR. b) RecA mini intein ESR1 bionsensor overlapping PCR product amplified
                            through normal amplification PCR. c) Digested RecA mini intein ESR1 biosensor with SpeI and
                            ScaI restriction enzymes*.</i></p>
                        <p className="p"><i>SpeI</i> restriction enzyme is not functional anymore, it has
                            been stored for many years. Therefore the only cut made was in ScaI
                            site, linearizing the plasmid.</p>
                        <p className="p"><i>E.coli</i> HMS174 chemocompetent cells were
                            transformed with “Plasmid RecA intein”. Colony taken for streak plate
                            in order to conserve a constant colony for IntAssay.</p>
                        <br></br>
                        <img
                            className="figure max-w-xl m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/results-biosensor/results-biosensor4.png"
                            alt="resultsbio"
                        ></img>
                        <p className="p">The lack of coloration is hypothesized to have occurred due
                            to an interaction affecting its ability to perform protein splicing;
                            this can be observed in a molecule docking between complexes. At the
                            same time, the usage of the <i>E.coli</i> HMS174 strain may have been faulty
                            or deficient in its protein expression.</p><br></br>
                        <h3
                            id="IntAssay_title"
                            className="text-3xl cano font-bold">IntAssay</h3>
                        <p className="p">● <b>In petri dishes</b> (accordingly to the
                            protocol book page 35) three negative controls (ethanol, IPTG and
                            bacteria only), petri dishes with BPA solutions were expected to
                            appear with bacteria expressing blue chromoprotein AmilCP, 4
                            concentrations were used, none of the bacteria expressed the
                            chromoprotein.</p>
                        <p className="p"> ● <b>Liquid medium</b> (protocol book page 35);
                            leaving the bacteria to grow until O.D. 0.6, then induced with IPTG
                            and after 6 hours, the bacteria was exposed to BPA solutions. The
                            final samples were centrifuged to accumulate the biomass expected to
                            appear blue to the naked eye. None of the bacteria expressed the
                            chromoprotein.</p>
                        <p className="p">After this assays, the lack of expression of the
                            protein was hypothesized to be related to the biodisponibility of the
                            bacteria while exposed to BPA, some protocol features were changed,
                            but also before repeating the assays changing the cloning vector pJET
                            2.1 to pET-17b expression vector was proposed.</p>
                        <br></br>
                        <h3
                            id="Immobilization_title"
                            className="text-3xl cano font-bold">Immobilization results</h3>
                        <h2 className="h2 font-bold cano">1. Nanoparticle synthesis 1</h2>
                        <p className="p">The formation of a quasi-hydrogel was observed due to the
                            concentration of chitosan (Figure 25). Red color in the samples
                            indicate the formation of gold, however, for the experiments seeked,
                            this was not useful as a colloid was needed.</p>
                        <br></br>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-hydrogelaunps.jpeg"
                            alt="biosensorlink"
                            className="figure max-w-xl m-auto"
                        ></img>
                        <p className="figure_desc">Fig 25. <i>Quasi-hydrogel formation of LMWC-AuNPs</i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">2. Quasi-hydrogel gold nanoparticles SEM</h2>
                        <p className="p">To confirm the formation of gold nanoparticles, and predict
                            their morphology, SEM was performed as described in protocol book.Gel formations were
                            observed, though no gold morphology is visualized due to the density of the obtained polymer
                            (Figure 26).</p>
                        <br></br>
                        <img
                            className="max-w-lg m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-peliculaacerobad.jpeg"
                            alt="biolink2"
                        ></img>
                        <p className="figure_desc">Fig 26. <i>SEM secondary electron (SEI) image of the quasi-hydrogel
                            LMWC-AuNPs</i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">3. Nanoparticle synthesis II</h2>
                        <p className="p">Since no colloidal solution was obtained, gold nanoparticles
                            were again synthesized as exposed in (link a bitacora). Results were
                            now favorable, both for a 0.125% and a 0.25% concentration of chitosan
                            (Figure 27).</p>
                        <br></br>
                        <img
                            className="max-w-lg m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-colloids.jpeg"
                            alt="biolink3"
                        ></img>
                        <p className="figure_desc">Fig 27. <i>Gold nanoparticles with a 0.125% (left) and 0.25%
                            (right) concentration of chitosan.</i></p>
                        <h2 className="h2 font-bold cano">4. 0.125% Ch spin-coating SEM</h2>
                        <p className="p">To visualize colloidal gold, a glass
                            substrate underwent spin-coating and was observed in SEM. No shape was
                            observed, hence, technique was changed (section V). Using EDS, gold
                            was detected in little proportion (Figure 28).</p>
                        <br></br>
                        <div className="flex justify-center max-w-lg m-auto">
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-substrate1.jpeg"
                                alt="buiolinksubstrate1"
                            ></img>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-edssubstrate1.jpeg"
                                alt="buiolinkedssubstrate1"
                            ></img>
                        </div>
                        <p className="figure_desc">Fig 28. <i>SEM secondary electron (SEI) and EDS spectra of a
                            substrate with gold nanoparticles prepared by spin coating.</i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">5. 0.25% Ch dip-coating SEM-EDS</h2>
                        <p className="p">Dip-coating was performed as in he notebook with the
                            purpose of obtaining more consistent results. Morphology was not
                            observed, again. Hypothesis comes down to the fact that, since AuNPs
                            are covered with chitosan. However, EDS analysis was performed, and Au
                            peaks and surface dots were detected, confirming the presence of gold
                            nanoparticles (Figure 29) in a greater proportion compared to spin
                            coating.</p>
                        <br></br>
                        <img
                            className="max-w-5xl m-auto"
                            src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-edsdipc.jpeg"
                            alt="buiolinkedsdipc"
                        ></img>
                        <p className="figure_desc">Fig 29. <i>SEM secondary electron (SEI) and EDS spectra of a
                            substrate with gold nanoparticles prepared by dip coating.</i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">6. Nanoparticle sizes and stability</h2>
                        <p className="p">Size, measured with Dynamic Light Scattering was 79.8 nm in average for the
                            0.125% Ch while 109.8 nm for 0.25% one. Sizes were not distributed equally, since in both
                            scenarios, there are secondary peaks around 5-40 nm. This can be explained with a rod shape
                            of the nanoparticles.</p>
                        <p className="p">On the other hand, using Electrophoretic Light Scattering, Zeta Potential was
                            measured. This indicates stability. The greater it is, rather negative or positive, the more
                            stable nanoparticles become. For the case of 0.125% Z potential resulted in 19.6 contrary to
                            0.25% where stability went ahead with a value of 39.33. This is relatable to the
                            concentration of chitosan. A balance should be found between LMWC concentration related to
                            size and stability.</p>
                        <br></br>

                        <h2 className="h2 font-bold cano">7. Nanoparticle topography</h2>
                        <p className="p">A glass-modified substrate with gold nanoparticles was prepared by dip coating
                            as written in the biosensor linkage worklog. This was scanned in AFM both substrate and
                            substrate with AuNPs to assess a change in topography (Fig. 30).</p>
                        <div className="flex justify-center max-w-9xl m-auto">
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-captura3.jpg"
                                alt="Fig1-sp"
                                className="figure"
                            ></img>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-captura5.jpg"
                                alt="buiolinkedssubstrate1"
                                className="figure"
                            ></img>
                        </div>
                        <p className="figure_desc">Fig 30. <i>Difference between the conductive glass substrate with a
                            thin film of gold nanoparticles (right) and the substrate without it (left). </i></p>
                        <br></br>
                        <p>With a horizontal slicer, topography is compared between the substrate with and without
                            nanoparticles. It was observed that maximum height in the substrate was around 5 nm contrary
                            to 80 nm peaks in the one with gold nanoparticles functionalized with chitosan (Fig.
                            31).</p>
                        <div className="flex justify-center max-w-9xl m-auto">
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-captura.jpg"
                                alt="Fig1-sp"
                                className="figure"
                            ></img>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-captura2.jpg"
                                alt="buiolinkedssubstra"
                                className="figure"
                            ></img>
                        </div>
                        <p className="figure_desc">Fig 31. <i>A comparison between a glass substrate without and with a
                            thin film of gold nanoparticles. </i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">8. Nanoparticles’ resonant properties</h2>
                        <p className="p">Metal nanoparticles in general possess resonant properties that enhance them
                            with an absorbance unique property. Thus, when there is a nanoparticle, UV-Vis is the ideal
                            test to confirm this attribute. That can be observed in Fig. 32 where AuNPs-Ch showed a
                            resonant wavelength around 553 nm.</p>
                        <img src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-uvaunps.jpeg " alt="nano"
                             className="figure max-w-5xl m-auto"/>
                        <p className="figure_desc">Fig 32. <i>UV–vis absorption spectra of gold nanoparticles. </i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">9. FTIR-ATR Spectrum</h2>
                        <p className="p">Fourier Transformed Infrared Spectrum assisted by Attenuated Total Reflection
                            (FTIR-ATR) is a technique not only to understand molecules but the effect of particles
                            around them. This is the case of chitosan (Fig. 31), where characteristic functional groups
                            such as primary amines (3000-2500 cm^-1) and alcohols (3500-3000 cm^-1) as in (Fig. 33).
                            These are preserved when chitosan capped gold nanoparticles are analyzed, however, due to a
                            low concentration of the sample, water shows up as the main molecule present (Fig. 34).</p>
                        <img src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-irch.jpeg " alt="nano"
                             className="figure max-w-5xl m-auto"/>
                        <p className="figure_desc">Fig 33. <i>FTIR-ATR spectra of low molecular weight chitosan.</i></p>
                        <img src="https://static.igem.wiki/teams/4260/wiki/biosensorlink-iraunps.jpeg  " alt="nano"
                             className="figure max-w-5xl m-auto"/>
                        <p className="figure_desc">Fig 34. <i>FTIR-ATR spectra of gold nanoparticles functionalized with
                            chitosan. </i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">10. Hardware mold adaptation</h2>
                        <p className="p">After 3D printing the mold designed in hardware, adaptations needed to be
                            performed since water was infiltrating, thus cyclic voltammetry would read cable’s
                            reduction. That is why a PDMS mold was engineered as in the biosensor linkage worklog. In
                            addition, channels were drawn with copper and xyz tape to immobilize the QCM on the mold and
                            connect the cables. After testing, water was no longer infiltrating.</p>
                        <br></br>
                        <h2 className="h2 font-bold cano">11. Cysteine deposition and cyclic voltammetry</h2>
                        <p className="p">After applying a 30 minute 0.01V pretreatment using a three-electrode
                            arrangement, a cyclic voltammetry at 0.2 mA is run to revise the cysteine deposition
                            profile. Cycle is stable, though 2mA limit encloses a possible upper profile, thus intensity
                            is changed to its maximum configuration.</p>
                        <p className="p">A second cyclic voltammogram was obtained but with an intensity limit of 10mA
                            and a complete oxidation-reduction stable graphic is obtained.</p>
                        <br></br>
                        <h2 className="h2 font-bold cano">12. Surface characterization: protein+NPs topography.</h2>
                        <p className="p">After incubating gold nanoparticles with a herɑ protein solution, dip coating
                            on a glass substrate was performed to assess a change in the topography of the sample.
                            Expected results were that topography should increase in the presence of a protein despite
                            not confirming chemical interaction (Fig. 35). This happened, and can be visualized in (Fig.
                            36). Glass substrate with AuNPs+herɑ displayed topographies up to 200 nm. Missing analytical
                            techniques would be helpful to characterize whether there is binding between chitosan and
                            the protein. </p>
                        <img src="https://static.igem.wiki/teams/4260/wiki/proteina.jpg" alt="nano"
                             className="figure max-w-5xl m-auto"/>
                        <p className="figure_desc">Fig 35. <i> AFM topography of the conductive glass substrate coated
                            with AuNPs+herɑ. </i></p>
                        <img src="https://static.igem.wiki/teams/4260/wiki/fotocomparativa2.jpg" alt="nano"
                             className="figure max-w-5xl m-auto"/>
                        <p className="figure_desc">Fig 36. <i>A comparison between a glass substrate without a thin film
                            (red), AuNPs’ coated (green) and AuNPs+herɑ (blue). </i></p>
                        <br></br>
                        <h2 className="h2 font-bold cano">13. QM Surface topography.</h2>
                        <p className="p">A new, polished, gold QCM electrode was characterized using Atomic Force
                            Microscopy for a further comparison with the functionalized surface. </p>
                        <br></br>
                        <h3
                            id="References_title"
                            className="text-3xl cano font-bold">References</h3>
                        <p className="reference">[1] Santos, G. A.A., Souza, J. C., Nóbrega, M. Q., Xavier, Y.
                            K., Felipe, M. A., & Torres, F. A. (2016). A novel structurally stable
                            multiepitope protein for detection of HCV. Hepatitis Research and
                            Treatment</p>
                    </div>
                </div>
            </div>
        </div>
    );
}